
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M256 120c-13.255 0-24 10.745-24 24v224c0 13.255 10.745 24 24 24s24-10.745 24-24V144c0-13.255-10.745-24-24-24zM176 168c-13.255 0-24 10.745-24 24v128c0 13.255 10.745 24 24 24s24-10.745 24-24V192c0-13.255-10.745-24-24-24zM392 232v48c0 13.255 10.745 24 24 24s24-10.745 24-24v-48c0-13.255-10.745-24-24-24s-24 10.745-24 24zM336 168c-13.255 0-24 10.745-24 24v128c0 13.255 10.745 24 24 24s24-10.745 24-24V192c0-13.255-10.745-24-24-24zM96 208c-13.255 0-24 10.745-24 24v48c0 13.255 10.745 24 24 24s24-10.745 24-24v-48c0-13.255-10.745-24-24-24z"}}),_c('path',{attrs:{"d":"M256 0C187.62 0 123.333 26.629 74.98 74.98 26.629 123.333 0 187.62 0 256s26.629 132.667 74.98 181.02C123.333 485.371 187.62 512 256 512s132.667-26.629 181.02-74.98C485.371 388.667 512 324.38 512 256s-26.629-132.667-74.98-181.02C388.667 26.629 324.38 0 256 0zm0 464c-114.691 0-208-93.309-208-208S141.309 48 256 48s208 93.309 208 208-93.309 208-208 208z"}})])
          )
        }
      }
    